export class ConfigurationDTO {
  maybeIE!: boolean;
  webApiBaseUrl!: string;
  staticWebApiUrl!: string;
  webHost!: string;
  staticWebUrl!: string;
  staticEnabled!: boolean;
  suggestionDeltaDays!: 0;
  videocallRequestEnabled!: boolean;
  isMaintenanceUpdateComingSoon!: string;
  maintenancePageEnabled!: string;
  maintenancePageEndDateAndTimeSentence!: string;
  companyCustomizations!: {
    companyId: string;
    purchaseActive: boolean;
    font: string;
    colors: {
      additionalProp1: string;
      additionalProp2: string;
      additionalProp3: string;
    };
    logos: {
      additionalProp1: string;
      additionalProp2: string;
      additionalProp3: string;
    };
    ssoIdentityProvider: string;
    ssoExternalUserIdParameter: string;
  };
  businessPartner!: string;
  bpTranslationJson!: string;
  cookiesParams!: {
    language: string;
    companyId: string;
    ssoExternalUserIdParameter: string;
    bpLogo: string;
    recognizedUrl: string;
    suffix: string;
  };
  botId!: string;
  preview!: boolean;
  facebookAppId!: string;
  googleAppId!: string;
  showGoogleLoginButton!: boolean;
  adultAge!: 0;
  calendarConfigUrl!: string;
}

export class UpdatePreferencesDTO {
  individualId!: string;
  language!: string;
  botAllowed!: boolean;
  multiLanguageAllowed!: boolean;
  travelServiceAllowed!: boolean;
  consultServiceAllowed!: boolean;
  personalServiceAllowed!: boolean;
  symptomsServiceAllowed!: boolean;
  careManagerServiceAllowed!: boolean;
}

export class RedeemCodeDTO {
  productId?: string;
  trackingCode?: string;
  activationCode!: string;
  companyId!: string;
  individualId!: string;
}

export class ScheduleDTO {
  description!: string;
  individualId!: string;
  phoneNumber!: string;
  emailAddress!: string;
  companyId!: string;
  templateCode!: string;
  languageCode!: string;
  creationDate!: Date;
  startDate!: Date;
  endDate!: Date;
  lastQueued!: Date;
  repeateEveryMinutes!: BigInteger;
  placeHolderValuesJSON!: string;
  toSchedule!: boolean;
  instanceCode!: string;
  serviceType!: string;
  imageLink!: [string];
  callToActionJSON!: string;
  dossierCode!: string;
  missionId!: string;
}

export class MedicalDataDTO {
  firstMeasurement?: MeasurementDTO;
  lastMeasurement?: MeasurementDTO;
}

export class MeasurementDTO {
  contactId?: string;
  weight?: number;
  height?: number;
  waistCircumference?: number;
  hipCircumference?: number;
  wristCircumference?: number;
  bloodGroup?: string;
  isSmoker?: boolean;
  numCigarettes?: number;
  bodyMassIndex?: number;
  note?: string;
  disclaimer?: boolean;
  lastTimeModified?: any;
}
